import { ActivityStep } from './types';
import { ACTIVITY_DETAILS_COLORS, ACTIVITY_DETAILS_SPACING, ACTIVITY_DETAILS_RADIUS, ACTIVITY_DETAILS_TYPOGRAPHY } from './constants';

interface StepItemProps {
  step: ActivityStep;
}

/**
 * StepItem Component
 * 
 * Individual numbered step with circular badge.
 * Responsive: Text scales 16px → 18px → 20px.
 */
export default function StepItem({ step }: StepItemProps) {
  // Helper to render text with bold keywords
  const renderStepText = (text: string) => {
    const parts = text.split(/(\*\*.*?\*\*)/g);
    return parts.map((part, index) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        const boldText = part.slice(2, -2);
        return (
          <strong
            key={index}
            className="font-semibold"
            style={{
              color: ACTIVITY_DETAILS_COLORS.textBody,
            }}
          >
            {boldText}
          </strong>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  return (
    <div className="flex gap-3">
      {/* Step Number Badge */}
      <div
        className="flex-shrink-0 flex items-center justify-center rounded-full"
        style={{
          width: `${ACTIVITY_DETAILS_SPACING.stepNumberSize}px`,
          height: `${ACTIVITY_DETAILS_SPACING.stepNumberSize}px`,
          backgroundColor: ACTIVITY_DETAILS_COLORS.stepNumberBg,
          borderRadius: `${ACTIVITY_DETAILS_RADIUS.stepBadge}px`,
        }}
      >
        <span
          className="font-bold text-xs"
          style={{
            fontFamily: 'DM Sans, sans-serif',
            color: ACTIVITY_DETAILS_COLORS.stepNumberText,
          }}
        >
          {step.id}
        </span>
      </div>

      {/* Step Text */}
      <p
        className={`${ACTIVITY_DETAILS_TYPOGRAPHY.body.weight} ${ACTIVITY_DETAILS_TYPOGRAPHY.body.sizeClasses} ${ACTIVITY_DETAILS_TYPOGRAPHY.body.leading}`}
        style={{
          fontFamily: 'DM Sans, sans-serif',
          color: ACTIVITY_DETAILS_COLORS.textSecondary,
          margin: 0,
        }}
      >
        {renderStepText(step.text)}
      </p>
    </div>
  );
}
